module.exports = __webpack_public_path__ + "static/bernard-c97343ba4afeab6844025be817437b5b.jpg";